import humps from 'humps'
import { defineAction } from '_utils/redux'
import * as aiIntegrationServices from '_services/ai-integration'

export const GET_ASSISTANTS = defineAction('GET_ASSISTANTS')
export const GET_ASSISTANT_BY_ID = defineAction('GET_ASSISTANT_BY_ID')
export const GET_ERROR_CORRECTION = defineAction('GET_ERROR_CORRECTION')
export const GET_AI_MODELS = defineAction('GET_AI_MODELS')

export const PATCH_ASSISTANT = defineAction('PATCH_ASSISTANT')
export const POST_ASSISTANT = defineAction('POST_ASSISTANT')
export const UPDATE_ERROR_CONNECTION = defineAction('UPDATE_ERROR_CONNECTION')

export const getAiAssistants = params => (dispatch, getState) => {
  const formattedParams = humps.decamelizeKeys(params)
  const data = aiIntegrationServices.getAiAssistants(getState().user.authToken)({
    ...formattedParams,
  })

  dispatch({
    type: GET_ASSISTANTS.ACTION,
    payload: data,
  })
  return data
}

export const getAssistantById = id => async (dispatch, getState) => {
  const data = await aiIntegrationServices.getAssistantByIdService(getState().user.authToken)(id)

  dispatch({
    type: GET_ASSISTANT_BY_ID.ACTION,
    payload: async () => data,
    meta: id,
  })
  return data
}

export const getAiErrorCorrection = params => (dispatch, getState) => {
  const formattedParams = humps.decamelizeKeys(params)
  const data = aiIntegrationServices.getAiErrorCorrection(getState().user.authToken)({
    ...formattedParams,
  })

  dispatch({
    type: GET_ERROR_CORRECTION.ACTION,
    payload: data,
  })
  return data
}

export const getAiModels = params => (dispatch, getState) => {
  const formattedParams = humps.decamelizeKeys(params)
  const data = aiIntegrationServices.getAiModels(getState().user.authToken)({
    ...formattedParams,
  })

  dispatch({
    type: GET_AI_MODELS.ACTION,
    payload: data,
  })
  return data
}

export const patchAssistant = (assistantId, payload) => async (dispatch, getState) => {
  const data = await aiIntegrationServices.patchAssistantService(getState().user.authToken)(
    assistantId,
    payload
  )

  dispatch({
    type: PATCH_ASSISTANT.ACTION,
    payload: async () => data,
  })

  return data
}

export const postAssistant = payload => async (dispatch, getState) => {
  const data = await aiIntegrationServices.postAssistantService(getState().user.authToken)(payload)

  dispatch({
    type: POST_ASSISTANT.ACTION,
    payload: async () => data,
  })
  return data
}

export const updateErrorCorrection = (id, payload) => async (dispatch, getState) => {
  const data = await aiIntegrationServices.updateAiErrorCorrectionService(
    getState().user.authToken
  )(id, payload)
  dispatch({
    type: UPDATE_ERROR_CONNECTION.ACTION,
    payload: async () => data,
  })
  return data
}

export const postAiResponse = payload => async (_dispatch, getState) => {
  const data = await aiIntegrationServices.postAiResponseService(getState().user.authToken)(payload)
  return data
}
